import gsap from 'gsap';

export const firstSlideEnter = (item) => {
	const tl = gsap.timeline({
		onComplete: () => {
			tl.pause();
		},
	});
	const text = item.querySelector('.layer--text');
	const image = item.querySelector('.layer--image');
	const wave = item.querySelector('.layer--wave');

	tl.fromTo(
		image,
		{
			opacity: 0,
			clipPath: 'polygon(40% 0%, 100% 0%, 100% 100%, 40% 100%)',
		},
		{
			duration: 1.25,
			clipPath: 'polygon(40% 0%, 100% 0%, 100% 100%, 40% 100%)',
			opacity: 1,
		}
	)
		.fromTo(
			text,
			{
				y: 100,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				duration: 2.75,
			}
		)
		.to(wave, {
			duration: 2,
			clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
		});

	return tl;
};

export const firstSlideExit = (item, nextItem) => {
	const tl = gsap.timeline();
	const text = item.querySelector('.layer--text');
	const image = item.querySelector('.layer--image');
	const wave = item.querySelector('.layer--wave');
	const nextText = nextItem.querySelector('.layer--text');
	const nextImage = nextItem.querySelector('.layer--image');
	const nextWave = nextItem.querySelector('.layer--wave');
	const listItems = nextItem.querySelectorAll('tr');

	tl.to(image, {
		duration: 2.5,
		clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
	})
		.to(text, {
			duration: 0,
			opacity: 0,
		})
		.to(wave, {
			duration: 0,
			opacity: 0,
		})
		.to(image, {
			duration: 1.25,
			opacity: 0,
			delay: 1.25,
		})
		.fromTo(
			nextImage,
			{
				opacity: 0,
			},
			{
				duration: 1.25,
				opacity: 1,
			}
		)
		.fromTo(
			nextText,
			{
				opacity: 0,
				y: 100,
			},
			{
				duration: 1.25,
				opacity: 1,
				y: 0,
			}
		)
		.fromTo(
			listItems,
			{
				opacity: 0,
				y: 100,
			},
			{
				duration: 1.25,
				opacity: 1,
				y: 0,
				stagger: 0.3,
			}
		);

	return tl;
};

export const secondSlideExit = (item, nextItem) => {
	const tl = gsap.timeline();
	const text = item.querySelector('.layer--text');
	const image = item.querySelector('.layer--image');

	tl.to(text, {
		opacity: 0,
		duration: 1.25,
	}).to(image, {
		opacity: 0,
		duration: 1.25,
	});

	return tl;
};

export const thirdSlide = (item) => {
	const tl = gsap.timeline();
	const text = item.querySelector('.layer--text');
	const wave = item.querySelector('.layer--wave');
	const highlights = item.querySelectorAll('.pxblock--highlights__list-item');

	tl.fromTo(
		highlights,
		{
			opacity: 0,
			y: 100,
		},
		{
			opacity: 1,
			y: 0,
			stagger: 4,
		}
	)
		.to(wave, {
			duration: 2,
			clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
		})
		.fromTo(
			wave,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				duration: 1,
			},
			'-=2'
		);

	return tl;
};
